module.exports = __webpack_public_path__ + "img/heroLarge.4268d6c3.jpg";